export enum ImportFileActionType {
  USERS = "Users",
  COMPANIES = "Companies",
  DRIVERS = "Drivers",
  VEHICLES = "Vehicles",
  PROFILES = "Profiles",
}

export enum ImportFileLabelType {
  USERS = "Create Users",
  COMPANIES = "Create Companies",
  DRIVERS = "Create Drivers",
  VEHICLES = "Create Vehicles",
  PROFILES = "Create Profiles",
}
